import { FieldLabel } from "src/Pages/WO/Components/upload/uploadModalUI";

// Building blocks of the Account page, in the app's current card style (the
// same palette and type as ModalShell and the IAM pages).

// A titled section: header with title and description, then the body, then an
// optional footer for the section's actions.
export const SettingsCard = ({ title, description, children, footer }) => (
  <section className="bg-white rounded-[12px] border border-[#E5E8F3] overflow-hidden">
    <div className="px-6 py-4 border-b border-[#E5E8F3]">
      <h2 className="font-OpenSansSemiBold text-[16px] leading-[24px] text-[#1A2332]">{title}</h2>
      {description && (
        <p className="mt-0.5 font-OpenSansRegular text-[13px] leading-[20px] text-[#7C829A]">{description}</p>
      )}
    </div>
    <div className="px-6 py-5">{children}</div>
    {footer && (
      <div className="px-6 py-4 border-t border-[#E5E8F3] bg-[#FAFBFE] flex items-center justify-end gap-3">
        {footer}
      </div>
    )}
  </section>
);

export const TextField = ({
  label,
  value,
  onChange,
  type = "text",
  placeholder,
  error,
  readOnly,
  autoComplete,
  onEnter,
}) => (
  <label className="flex flex-col gap-1">
    <FieldLabel>{label}</FieldLabel>
    <input
      type={type}
      value={value}
      readOnly={readOnly}
      placeholder={placeholder}
      autoComplete={autoComplete}
      onChange={(e) => onChange?.(e.target.value)}
      onKeyDown={(e) => {
        // Enter submits the section. Not while an input method (e.g. Korean)
        // is still composing a character.
        if (e.key === "Enter" && !e.nativeEvent.isComposing) onEnter?.();
      }}
      className={`h-[44px] px-3 border rounded-[6px] outline-none font-OpenSansRegular text-[14px] leading-[20px] tracking-[0.14px] ${
        readOnly ? "bg-[#F8F9FE] text-[#7C829A] cursor-default" : "bg-white text-[#1A2332] focus:border-[#73A7FF]"
      } ${error ? "border-red-500" : "border-[#E5E8F3]"}`}
    />
  </label>
);

// The quieter companion of PrimaryButton, same height.
export const SecondaryButton = ({ children, onClick, disabled }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={`h-[40px] px-5 rounded-[8px] bg-white border border-[#C9CEE2] flex items-center justify-center font-OpenSansSemiBold text-[14px] text-[#1A2332] ${
      disabled ? "opacity-60 cursor-not-allowed" : "cursor-pointer hover:bg-[#F8F9FE]"
    }`}
  >
    {children}
  </button>
);
